// extracted by mini-css-extract-plugin
export default {"contactSection":"Contact_contactSection__M8eTj","contactText":"Contact_contactText__-zvIi","info":"Contact_info__YSJ+m","icons":"Contact_icons__OSDoy"};